import { z } from "zod";
import { state } from "./fsecureOrchestrator";

export const fsecureReactivationOrchestrator = z.object({
  type: z.literal("NJU_FSECURE_REACTIVATION"),
  state,
  id: z.string(),
  products: z.object({
    id: z.string(),
    specificationId: z.literal("FSECURE"),
    vlocityOfferId: z.string(),
  }),
  orderSummary: z.object({
    totalOrderPrice: z.number(),
    totalRecurringOrderPrice: z.number(),
    totalOneTimeOrderPrice: z.number(),
    items: z.array(
      z.object({
        offerId: z.string(),
        offerPrice: z.number(),
        offerPriceType: z.string(),
      }),
    ),
  }),
});

export type IFsecureReactivationOrchestrator = z.infer<
  typeof fsecureReactivationOrchestrator
>;
